export default "__VITE_ASSET__f3246ca2__"